export enum ChannelStatus {
  Unknown = 'unknown',
  Waiting = 'waiting',
  Active = 'active',
  Transferred = 'transferred',
  Ended = 'ended',
}

export enum BotResponseRating {
  Up = 'UP',
  None = 'NONE',
  Down = 'DOWN',
}

export enum CSATRating {
  Up = 'UP',
  None = 'NONE',
  Down = 'DOWN',
}
